module.exports = __webpack_public_path__ + "static/media/Special.42279777.pdf";